var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays the missing-document step for break-in damages and allows the user to skip it.
 * touches: claim store, MissingDocumentCard, claim payload persistence, declaration steps.
 * invariants: skipping marks the initial missing-file step as validated and saves the BreakInDamagesMissingFile step before continuing.
 * inputs: current claim state and the user's skip action.
 * outputs: renders the missing-document information and persists the skip decision via saveClaimWithPayload.
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiCard } from '@claims-ia/design-system';
import MissingDocumentCard from '@declaration/components/receipt/MissingDocumentCard.vue';
import { Step } from '@shared/claim/steps';
const claim = namespace('claim');
let BreakInDamagesMissingFile = class BreakInDamagesMissingFile extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
    }
    async skip() {
        this.loading = true;
        await this.saveClaimWithPayload({
            isMissingInitialFileStepValidated: true,
            step: Step.BreakInDamagesMissingFile,
        });
        this.loading = false;
    }
};
__decorate([
    claim.Action('saveClaimWithPayload')
], BreakInDamagesMissingFile.prototype, "saveClaimWithPayload", void 0);
BreakInDamagesMissingFile = __decorate([
    Component({
        components: {
            MissingDocumentCard,
            UiCard,
        },
    })
], BreakInDamagesMissingFile);
export default BreakInDamagesMissingFile;
